import { render, staticRenderFns } from "./DisclaimerDialogue.vue?vue&type=template&id=435d7fda&"
import script from "./DisclaimerDialogue.vue?vue&type=script&lang=js&"
export * from "./DisclaimerDialogue.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerDialogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports